let settingsFallBack = {
  content: {
    title: "Internet Explorer isn't supported",
    description: "We don't provide support for this browser"
  },
  browsers: [
    {
      name: "Chrome",
      link: "https://www.google.com/intl/en/chrome/",
      download_text: "Download Chrome",
      classes: ["btn", "btn-primary"]
    },
    {
      name: "Firefox",
      link: "https://www.mozilla.org/firefox/new/",
      download_text: "Download Firefox",
      classes: ["btn", "btn-primary"]
    }
  ],
  styles: {
    wrapper: ["ieWrapper"],
    modal: ["ieModal"]
  }
};

function applyClassToElement(element, classes) {
  console.log("elements", element);
  classes.forEach(cssClass => {
    element.classList.add(cssClass);
  });
}

function createDownloadButton(element) {
  let downloadButton = document.createElement("a");
  applyClassToElement(downloadButton, element.classes);
  downloadButton.innerText = element.download_text;
  downloadButton.href = element.link;
  downloadButton.target = "_blank";
  return downloadButton;
}

function createIeDisclaimer(settings) {
  const CURRENT_SETTING = settings.content || settingsFallBack.content;
  const BODY = document.querySelector("body");
  const IE_WRAPPER_CLASSES = (settings.styles || settingsFallBack.styles).wrapper
  const IE_MODAL_CLASSES = (settings.styles || settingsFallBack.styles).modal
  const BROWSERS = settings.browsers || settingsFallBack.browsers;
  let ieWrapperBox = document.createElement("div");
  let ieBox = document.createElement("div");
  let ieParagraph = document.createElement("p");
  ieParagraph.innerText = CURRENT_SETTING.description;
  ieBox.appendChild(ieParagraph);
  Object.values(BROWSERS).forEach(button => {
    ieBox.appendChild(createDownloadButton(button));
  });
  applyClassToElement(ieBox, IE_MODAL_CLASSES);
  ieWrapperBox.appendChild(ieBox);
  applyClassToElement(ieWrapperBox, IE_WRAPPER_CLASSES);
  BODY.appendChild(ieWrapperBox);
}

if(window){
  window.createIeDisclaimer = createIeDisclaimer;
}


console.log("iebox")